import { Api } from "../config/request";
import { _authorizationHeaders } from "../config/request";

export const getRideList = (payload) => {
    return Api.postRequest(`admins/rides`, payload);
};

export const getRideById = (rideId) => {
    return Api.getRequest(`admins/rides/${rideId}`);
};

export const uploadRideImage = (rideId, formData) => {
    return Api.postRequest(`rides/upload_image/${rideId}`, formData, {
        ..._authorizationHeaders(),
        // 'Content-Type': 'multipart/form-data',
    });
};

export const deleteRideImage = (rideId) => {
    return Api.deleteRequest(`rides/delete_image/${rideId}`);
};

const RideAPI = {
    getRideList,
    getRideById,
    uploadRideImage,
    deleteRideImage,
};

export default RideAPI;